<div>
    @if (title) {
        <p class="text-dark h4 font-500">{{ title }}</p>
    }
    <div class="flex justify-content-space-between align-items-center ion-margin-bottom">
        <p class="ion-no-margin text-dark" [ngClass]="{ 'h4 font-500 margin-none-important': labelAsTitle }">
            {{ label }}
        </p>
        <p class="ion-no-margin">
            @if (dualKnobs() && !!valueDual) {
                @if (unitAsDollarValue()) {
                    {{ valueDual.lower | currencyCustom }} {{ valueDual.lower === 1 ? unit : unitPlural }} -
                    {{ valueDual.upper | currencyCustom }} {{ valueDual.upper === 1 ? unit : unitPlural
                    }}{{ valueDual.upper === max && displayPlusForMax ? '+' : '' }}
                } @else {
                    {{ valueDual.lower }} {{ valueDual.lower === 1 ? unit : unitPlural }} - {{ valueDual.upper }}
                    {{ valueDual.upper === 1 ? unit : unitPlural
                    }}{{ valueDual.upper === max && displayPlusForMax ? '+' : '' }}
                }
            } @else {
                {{ value }} {{ value === 1 ? unit : unitPlural }}{{ value === max && displayPlusForMax ? '+' : '' }}
            }
        </p>
    </div>
    <ion-range
        (ionInput)="onRangeInput($event)"
        (ionChange)="rangeChange($event)"
        [snaps]="true"
        [ticks]="false"
        [step]="step"
        [min]="min"
        [max]="max"
        [value]="dualKnobs() ? valueDual : value"
        [dualKnobs]="dualKnobs()" />
</div>
